//用户列表的功能
import request from './request'

//获取消息列表
export function _userMessageList(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/message/index',
    })
    return request(config)
}

// 消息回复/编辑  私人消息和全员消息
export function _replyMessage(data = {}) {
    const config = Object.assign(data, {
      method: 'post',
      url: '/admin/message/edit',
    })
    return request(config)
}

//消息撤回
export function _reBackMessage(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/message/rollback',
  })
  return request(config)
}


//系统消息撤回
export function _reBackUserMessage(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/message/user-rollback',
  })
  return request(config)
}

//用户系统消息编辑
export function _UserSyMessageEdit(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/messge/user-edit',
  })
  return request(config)
}

//系统消息列表
export function _userSyMessage(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/message/user',
  })
  return request(config)
}


